module.exports = __webpack_public_path__ + "img/USDT.9d67538d.svg";